import { Injectable } from '@angular/core';
import { AlertController, ToastController } from '@ionic/angular';
import { ActionSheetController } from '@ionic/angular';


@Injectable({
  providedIn: 'root'
})

export class HelperService {

  constructor(
    public toastController: ToastController,
    public alertController: AlertController,
    private actionSheetCtrl: ActionSheetController
  ) { }

  public delay(delayInms: number) {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve(2);
      }, delayInms);
    });
  }

  public async toastChangesSaved(delayInms: number = 500) {
    const toast = await this.toastController.create({
      message: 'Your changes have been saved.',
      duration: 2000
    });
    toast.present();
    await this.delay(delayInms);
  }

  public async toastChangesDiscarded() {
    const toast = await this.toastController.create({
      message: 'Your changes have been discarded.',
      duration: 2000
    });
    toast.present();
  }

  public async toastErrorSaving() {
    const toast = await this.toastController.create({
      message: 'Your changes could not be saved.',
      duration: 2000
    });
    toast.present();
  }


  public async toast(message: string) {
    await this.toastFull(message, "", 3000);
  }

  public async toastFull(message: string, buttonText: string = '', duration: number = 3000) {

    let buttons: any[] = [];
    if (buttonText === '') {
      buttons = [];
    } else {
      buttons = [
        {
          text: buttonText,
          role: 'cancel',
        }
      ]
    }

    const toast = await this.toastController.create({
      message: message,
      buttons: buttons,
      duration: duration
    });
    toast.present();
  }


  public async showAlert(message: string, buttonText: string = 'Ok') {
    // this.showAlertMobile();
    this.showAlertDesktop(message, buttonText);
    return;
  }

  public async showAlertDesktop(message: string, buttonText: string = 'Ok') {

    const alert = await this.alertController.create({
      cssClass: 'my-custom-question',
      message: message,
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          cssClass: 'my-custom-cancel',
        },
        {
          text: buttonText,
          role: 'cancel',
          cssClass: 'my-custom-confirm',
        }
      ],
    });
    await alert.present();
  }


  async showAlertMobile() {
    const actionSheet = await this.actionSheetCtrl.create({
      header: 'Example header',
      subHeader: 'Example subheader',
      cssClass: 'style-action-sheet',
      buttons: [
        {
          text: 'Delete',
          role: 'destructive',
          data: {
            action: 'delete',
          },
        },
        {
          text: 'Share',
          data: {
            action: 'share',
          },
        },
        {
          text: 'Cancel',
          role: 'cancel',
          data: {
            action: 'cancel',
          },
        },
      ],
    });

    await actionSheet.present();

    const result = await actionSheet.onDidDismiss();
    // this.result = JSON.stringify(result, null, 2);
  }

}
